import {
  AgentRequest,
  AgentRequestCount,
  AgentRequestCounts,
  NewAgentRequest,
} from "./agent-request.model";
import { QuoteMapper } from "./quote.mapper";

export class AgentRequestMapper {
  public static map(data: any): AgentRequest {
    if (!data) {
      return null;
    }

    return new AgentRequest(
      data.id,
      data.status,
      data.type,
      AgentRequestMapper.toDate(data.updatedAt),
      AgentRequestMapper.toDate(data.sentAt),
      data.agentName ?? null,
      data.clientName ?? null,
      data.sentByName ?? null,
      data.quoteId ?? null,
      data.quoteType ?? null,
      AgentRequestMapper.toDate(data.quoteValidTo),
      data.originLegId ?? null,
      data.originName ?? null,
      data.destinationLegId ?? null,
      data.destinationName ?? null,
      QuoteMapper.map(data.quote),
      data.details ?? null,
    );
  }

  public static mapCounts(data: any[]): AgentRequestCounts {
    return new AgentRequestCounts(
      (data ?? []).map(
        (count) =>
          new AgentRequestCount(
            count.type,
            count.originLegId ?? null,
            count.destinationLegId ?? null,
            count.originLocationId ?? null,
            count.destinationLocationId ?? null,
            count.count,
          ),
      ),
    );
  }

  public static toPayload(request: NewAgentRequest): Record<string, unknown> {
    return {
      type: request.type,
      agents: request.agentIds,
      originLeg: request.originLegId,
      destinationLeg: request.destinationLegId,
      subject: request.subject,
      message: request.message,
      attachments: request.attachments,
    };
  }

  private static toDate(value: string | null | undefined): Date | null {
    return value ? new Date(value) : null;
  }
}
